var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-login-5" }, [
    _c("div", { staticClass: "row bs-reset" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6 login-container bs-reset" }, [
        _c(
          "div",
          {
            staticClass: "login-content",
            staticStyle: { "margin-top": "20%", "padding-left": "20%" }
          },
          [
            _c("img", {
              staticStyle: { "margin-bottom": "10%", width: "300px" },
              attrs: { src: require("../assets/global/img/logo.png") }
            }),
            _vm._v(" "),
            _c("h3", { staticStyle: { "font-size": "36px" } }, [
              _vm._v("视网么AR内容管理系统")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(" 欢迎使用视网么CMS，发布管理您的AR素材内容！ ")]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "login-form",
                staticStyle: { "margin-top": "40px" },
                attrs: {
                  role: "form",
                  action: "javascript:;",
                  method: "post",
                  id: "loginform"
                }
              },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "name" } }, [_vm._v("帐号")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.account,
                        expression: "account"
                      }
                    ],
                    staticClass:
                      "form-control form-control-solid placeholder-no-fix form-group input-style",
                    staticStyle: { width: "50%" },
                    attrs: {
                      type: "text",
                      autocomplete: "off",
                      placeholder: "请输入用户名",
                      name: "account",
                      required: ""
                    },
                    domProps: { value: _vm.account },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.account = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "inputfile" } }, [
                    _vm._v("密码")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      }
                    ],
                    staticClass:
                      "form-control form-control-solid placeholder-no-fix form-group input-style",
                    staticStyle: { width: "50%" },
                    attrs: {
                      type: "password",
                      autocomplete: "off",
                      placeholder: "请输入密码",
                      name: "password",
                      required: ""
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _vm._m(1)
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(2)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-md-6 bs-reset",
        staticStyle: { position: "relative" }
      },
      [
        _c("div", { staticClass: "login-bg" }, [
          _c("img", {
            staticClass: "bg",
            attrs: { src: require("../assets/pages/img/login/bg1.jpg") }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "bg",
            attrs: { src: require("../assets/pages/img/login/bg2.jpg") }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "login-mark" }, [
          _c("img", {
            attrs: {
              src: require("../assets/pages/img/login/mark.png"),
              width: "100%"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "login-fg" }, [
          _c("div", { staticClass: "login-content pull-left" }, [
            _c("p", { staticClass: "title" }, [_vm._v("新用户注册")]),
            _vm._v(" "),
            _c("p", [
              _c("img", {
                staticClass: "num",
                attrs: {
                  src: require("../assets/pages/img/login/01.png"),
                  width: "15px"
                }
              }),
              _vm._v("扫描下载“视网么AR”APP")
            ]),
            _vm._v(" "),
            _c("p", [
              _c("img", {
                staticClass: "num",
                attrs: {
                  src: require("../assets/pages/img/login/02.png"),
                  width: "15px"
                }
              }),
              _vm._v("用手机号注册")
            ]),
            _vm._v(" "),
            _c("p", [
              _c("img", {
                staticClass: "num",
                attrs: {
                  src: require("../assets/pages/img/login/03.png"),
                  width: "15px"
                }
              }),
              _vm._v("使用手机号/帐号登录视网么CMS")
            ])
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "qr-code pull-right",
            attrs: {
              src: require("../assets/pages/img/login/qrcode.jpg"),
              width: "130px"
            }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "50%", position: "relative" } }, [
      _c(
        "button",
        { staticClass: "btn blue btn-style", attrs: { type: "submit" } },
        [_vm._v("登录")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "login-footer", staticStyle: { "padding-left": "20%" } },
      [
        _c("div", { staticClass: "row bs-reset" }, [
          _c("div", { staticClass: "col-xs-7 bs-reset" }, [
            _c("div", { staticClass: "login-copyright copyright-style" }, [
              _c("p", [_vm._v("Copyrights © 2019 视网么版权所有")]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "http://www.beian.miit.gov.cn"
                    }
                  },
                  [_vm._v("苏ICP备16011685号-1")]
                )
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }